var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.719 3H6.656c-.736 0-1.34.45-1.603 1.097l-2.681 6.347c-.08.206-.122.422-.122.656v1.81c0 .988.797 2.09 1.772 2.09h5.592l-.844 3.82-.028.282c0 .37.15.707.39.951l.937.942 5.915-5.962c.32-.324.516-.774.516-1.27v-9c0-.99-.806-1.763-1.781-1.763Zm4.031 0h3v10.5h-3V3Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.950047cc.svg";
export { ForwardRef as ReactComponent };